import React, { Fragment, useState } from 'react';
import { useAsync } from 'react-async';
import { useHistory } from 'react-router';
import { createDiscipline } from '../../../api/services/disciplineService';
import { ResponseStatus } from '../../../components/notifications';
import { FieldInput } from '../../../components/fieldInput';
import Layout from '../../../components/layout';
import SubmitButton from '../../../components/submitButton';
import { selectOption } from '../../../types/selectOption';
import { getDisciplineGroups } from '../../../api/services/disciplineGroupService';
import DisciplineGroup from '../../../api/models/disciplineGroup';
import SelectMulti from 'react-select';
import { graySelectStyles } from '../../../common/selectStyles';

const CreateDisciplines = () => {
  const history = useHistory();
  const [disciplineName, setDisciplineName] = useState('');
  const [disciplineGroupId, setDisciplineGroupId] = useState<number>(0);
  const [disciplineGroupOptions, setDisciplineGroupOptions] = useState<any[]>([]);

  const saveDiscipline = async () => {
    return await createDiscipline({
      name: disciplineName,
      disciplineGroupId: disciplineGroupId
    });
  };

  const save = useAsync({
    deferFn: saveDiscipline,
    onResolve: () => {
      history.push('/admin/disciplines', {
        message: `${disciplineName} added successfully!`,
      });
    },
  });

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    save.run();
  };

  //Get the disciplines
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const disciplineGroupsData = useAsync({
    promiseFn: getDisciplineGroups,
    onResolve: (r) => {
      const dg: DisciplineGroup[] = r.data.disciplineGroups;
      const dgOptions: selectOption[] = [];

      //Loop through the disciplines to generate the options for the multi select
      (dg.map((group) => (
        dgOptions.push({ value: group.disciplineGroupId ?? 0, label: group.name })
      )));
      dgOptions.sort((a, b) => {
        return a.label.localeCompare(b.label);
      });
      setDisciplineGroupOptions(dgOptions);
    }
  });

  return (
    <Layout>
      <Fragment>
        <ResponseStatus state={save} />
        <form onSubmit={handleSubmit}>
          <div className='grid grid-cols-6 gap-6 mb-6'>
            <div className='col-span-6 sm:col-span-6'>
              <FieldInput
                name='discipline'
                label='Discipline'
                minLength={1}
                onChange={(e) => setDisciplineName(e.target.value)}
                value={disciplineName}
              />
            </div>
          </div>
          <div className='grid grid-cols-6 gap-6 mb-6'>
            <div className='col-span-6 sm:col-span-6'>
              <label className="block mb-1">Discipline Group</label>
              <div className='col-span-6 sm:col-span-6'>
                <SelectMulti
                  isMulti={false}
                  name='discipline-group'
                  options={disciplineGroupOptions}
                  onChange={(opt: any) => setDisciplineGroupId(opt.value)}
                  styles={graySelectStyles}
                />
              </div>
            </div>
          </div>
          <div className='text-right'>
            <SubmitButton
              text='Create Discipline'
              spinning={save.isPending}
              disabled={disciplineName.length === 0}
            />
          </div>
        </form>
      </Fragment>
    </Layout>
  );
};

export default CreateDisciplines;
